import * as ui from "../../../../core/ui";

var view = () => new ui.Container({
    id: "CustomizableWidgetEditor",
    bsc: "col-lg-12",
    classes: "pad-l-5 pad-r-5",
    components: [
        new ui.Container({
            id: "EditJson",
            classes: "widget-editor",
            containerClasses: "mar-b-5"
        }),
        new ui.Button({
            id: "CancelJson",
            label: "Cancel",
            disabled: false
        }),
        new ui.Button({
            id: "SaveJson",
            label: "Save",
            bsc: "right",
            disabled: false
        })
    ]
});

export default view;
